import React, { useState, useEffect } from 'react';
import { Container, Grid, CircularProgress, Typography, Box } from '@mui/material';
import { useGetFieldsQuery, useGetCasesQuery } from '../store/api/apiSlice';
import { ClinicalFieldSelect } from '../components/DiagnosisComponents/ClinicalFieldSelect';
import { PatientCaseCard } from '../components/DiagnosisComponents/PatientCardCase' ;
import { CaseDetailsDialog } from '../components/DiagnosisComponents/CaseDetailsDialog';  
import type { DynamicCase, DynamicField } from '../types';
import '../styles/CasesPage.css'

export const DiagnosticPage: React.FC = () => {
  const [selectedField, setSelectedField] = useState('');
  const [selectedCase, setSelectedCase] = useState<DynamicCase | null>(null);

  // RTK Query hooks
  const { data: fields = [], isLoading: fieldsLoading } = useGetFieldsQuery();
  const { 
    data: cases = [], 
    isLoading: casesLoading 
  } = useGetCasesQuery(
    { fieldId: selectedField },
    { skip: !selectedField }
  );

  // Set default field when fields are loaded
  useEffect(() => {
    if (fields.length > 0 && !selectedField) {
      setSelectedField(fields[0].field_id);
    }
  }, [fields, selectedField]);

  return (
    <Container >
      <Typography variant="h4" sx={{color: 'text.primary' , mb: 2}} >
        Case Library
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Browse and study medical cases for different clinical fields
      </Typography>
      <Box>
        <ClinicalFieldSelect
          fields={fields}
          selectedFieldId={selectedField}
          onChange={setSelectedField}
        />
      </Box>

      {casesLoading ? (
        <Grid container justifyContent="center" sx={{ mt: 6 }}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid container spacing={2} sx={{ height: '100%' }}>
          {cases.filter(c => c.processing_status !== 'review_required').map((c) => (
            <Grid 
              key={c.id} 
              size={{xs:12 , sm :12 , md:6}}
              sx={{alignItems: 'stretch'}}
            >
                <PatientCaseCard
                selectedField={selectedField}
                patientCase={c}
                onViewDetails={(pc) => setSelectedCase(pc)}
                />
              </Grid>
          ))}
        </Grid>
      )}

      <CaseDetailsDialog
        open={Boolean(selectedCase)}
        patientCase={selectedCase}
        onClose={() => setSelectedCase(null)}
      />
    </Container>
  );
};
